import { call, all } from "redux-saga/effects";

//sagas
import { featureFlagSaga } from "./featureFlag/featureFlagSaga";

export default function* rootSaga() {
  yield all([call(featureFlagSaga)]);
}
